<template>
  <div class="member-invite-flow">
    <member-invite-enter-details v-if="this.currentFlowStep === this.inviteMemberFlowSteps.enterDetails"
                           :next="() => setCurrentFlowStep(inviteMemberFlowSteps.enterCode)"/>
    <member-invite-enter-code v-if="this.currentFlowStep === this.inviteMemberFlowSteps.enterCode"
                              :next="() => setCurrentFlowStep(inviteMemberFlowSteps.done)"/>
    <member-invite-done v-if="this.currentFlowStep === this.inviteMemberFlowSteps.done" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import MemberInviteEnterDetails from './pages/MemberInviteEnterDetails.vue';
import MemberInviteEnterCode from './pages/MemberInviteEnterCode.vue';
import MemberInviteDone from './pages/MemberInviteDone.vue';

export default {
  name: 'MemberInviteFlow',
  components: {
    MemberInviteEnterDetails,
    MemberInviteEnterCode,
    MemberInviteDone,
  },
  computed: {
    ...mapState('memberInvite', ['currentFlowStep']),
    ...mapGetters('memberInvite', ['inviteMemberFlowSteps']),
  },
  methods: {
    ...mapMutations('memberInvite', ['setCurrentFlowStep']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/invite-authenticated/member-invite/MemberInviteFlow.vue